var utils = require('../../../lib/utils')

module.exports = {
	model: {
		nrOfElements: -1
	},

	events: {
		open: {
			type: 'click',
			action: function(event) {
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $target = $(event.target).closest('button');


				if($target.length > 0) {
					var mode = $target.data('buttonMode');

					if(mode === 'empty') {
						self.empty()
					} else if(mode === 'reset'){
						self.reset()
					} else {
						var presetFilterParams = {}
						if(mode === 'selected'){
							presetFilterParams.limitByCheckboxSelection = 1;
						}
						self.open(undefined, undefined, { treeFilters: {
							presetFilterParams
						}});
					}
				}
			}
		}
	},

	methods: {
		prepare: function(){
			if(this.model.nrOfElements < 0){
				this.model.nrOfElements = utils.collectionSize(this.model.dataJSON)
			}
		},

		open: function(ckEditorButton, overrideDirtyAssignedRoutes, additionalResourceRegisters){
			var self = this;
			var assignedRoutes;
			if(overrideDirtyAssignedRoutes !== undefined){
				assignedRoutes = overrideDirtyAssignedRoutes;
			} else if(utils.collectionSize(self.model.dirtyAssignedRoutes) > 0){
				assignedRoutes = self.model.dirtyAssignedRoutes;
			} else if(self.model.dataJSON){
				assignedRoutes = self.model.dataJSON;
			}
			self.model.ckEditorButton = ckEditorButton;

			self.performAndStoreAction(
				'routePickerModal',
				self.prepareAction(
					'showRoutePicker',
					undefined,
					{
						assignedRoutes,
						selectionConfig: {
							multiSelect: (self.model.config || {}).multiSelect || false,
							selectCascade: (self.model.config || {}).selectCascade || '',
							usePrimaryKeyAsObjectKeyDataFormat: (self.model.config || {}).usePrimaryKeyAsObjectKeyDataFormat || false
						},
						...(additionalResourceRegisters || {})
					}, {
						source: {
							load: {
								componentData: {
									config: {
										overruleCKEditor: !!ckEditorButton
									}
								}
							}
						}
					}
				),
				true
			);
		},

		empty: function(){
			var self = this;

			self.model.dirtyAssignedRoutes = {}

			self.triggerClosest('onChildChanged', {
				fieldCode: self.model.fieldCode,
				value: self.model.dirtyAssignedRoutes
			});
			self.model.nrOfElements = utils.collectionSize(self.model.dirtyAssignedRoutes);
			self.refresh(false);
		},

		reset: function(){
			var self = this;

			self.model.dirtyAssignedRoutes = {}

			self.triggerClosest('onChildChanged', {
				fieldCode: self.model.fieldCode
			});
			self.model.nrOfElements = utils.collectionSize(self.model.dataJSON);
			self.refresh(false);
		}
	},

	hooks: {
		onDecision: function($element, options){
			// decisionComponent: <selectRouteTrees>,
			// decisionType: 'submit',
			// decisionOptions: <decisionOptions>,
			// data: <listOfSelectedEntities> [{<properties>, ...}, ...]
			var self = this;
			options = options || {};

			switch(options.decisionType){
				case 'decisionComponent':
					if(options.decisionComponent && options.decisionComponent.hasClass('base_modal_modal')){
						options.decisionComponent.hide();
					}

					if(self.model.ckEditorButton){
						var rI = Object.keys(self.model.dirtyAssignedRoutes || {})[0] || 0;
						var routeID = ((self.model.dirtyAssignedRoutes || {})[rI] || {}).routeID
						if(routeID) self.model.ckEditorButton.setValue(routeID);
					} else {
						this.triggerClosest('onChildChanged', {
							fieldCode: this.model.fieldCode,
							value: this.model.dirtyAssignedRoutes
						});
						self.model.nrOfElements = utils.collectionSize(self.model.dirtyAssignedRoutes);
						self.refresh(false);
					}
					break;

				case 'submit':
					self.model.dirtyAssignedRoutes = {};
					var routeCounter = 0;
					var modelConfig = self.model.config || {};
					utils.forEach(options.data || {}, function(route){
						route = route || {};
						if(route.routeID){
							if(route.unselect){
								if(modelConfig.usePrimaryKeyAsObjectKeyDataFormat){
									delete self.model.dirtyAssignedRoutes[route.routeID];
								} else {
									for(var routeIndex in self.model.dirtyAssignedRoutes){
										if((self.model.dirtyAssignedRoutes[routeIndex] || {}).routeID === route.routeID){
											delete self.model.dirtyAssignedRoutes[routeIndex];
											break;
										}
									}
								}
							} else {
								if(modelConfig.usePrimaryKeyAsObjectKeyDataFormat){
									self.model.dirtyAssignedRoutes[route.routeID] = {
										routeID: route.routeID
									};
								} else {
									self.model.dirtyAssignedRoutes[routeCounter++] = {
										routeID: route.routeID
									};
								}
							}
						}
					});

					// cleanup indexes if necessary
					if(!modelConfig.usePrimaryKeyAsObjectKeyDataFormat){
						routeCounter = 0;
						var dirtyAssignedRoutes = {};
						for(var routeIndex in self.model.dirtyAssignedRoutes){
							dirtyAssignedRoutes[routeCounter++] = self.model.dirtyAssignedRoutes[routeIndex];
						}
						self.model.dirtyAssignedRoutes = dirtyAssignedRoutes;
					}

					break;

				case 'cancel':
				default:
					if(options.decisionComponent && options.decisionComponent.hasClass('base_modal_modal')){
						options.decisionComponent.hide();
					}
					break;
			}
		}
	}
}